import { Link } from "react-router-dom";
import { Users, ArrowUpRight, Loader2 } from "lucide-react";
import { IMAGES } from "../lib/data";
import { PageHeader } from "../components/PageHeader";
import { Btn, Eyebrow } from "../components/ui-kit";
import { Reveal } from "../lib/motion";
import { useContent, resolveImg } from "../lib/api";

const imgs = [IMAGES.welcome, IMAGES.crowd, IMAGES.fellowship, IMAGES.hands, IMAGES.choir, IMAGES.worshipHands];

export default function Ministries() {
  const { data: MINISTRY_LIST, loading } = useContent("ministries");
  return (
    <div data-testid="ministries-page">
      <PageHeader eyebrow="Get Connected" title={"Get\nConnected"} sub="There's a place for you at One Love. Find a ministry where you can grow, serve, and build lasting friendships." image={IMAGES.fellowship} />

      <section className="py-24 sm:py-32 bg-white">
        {loading && <div className="py-10 grid place-items-center"><Loader2 className="animate-spin text-[#E63946]" size={32} /></div>}
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {(MINISTRY_LIST || []).map((m, i) => (
            <Reveal key={m.id || m.name} delay={(i % 3) * 0.08} className="group flex flex-col">
              <div className="overflow-hidden rounded-sm aspect-[16/10] mb-5 bg-[#F4F4F5]">
                <img src={m.image ? resolveImg(m.image) : imgs[i % imgs.length]} alt={m.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <h3 className="font-display font-bold text-xl mb-2">{m.name}</h3>
              <p className="text-black/60 leading-relaxed mb-4 flex-1">{m.desc}</p>
              <div className="text-sm text-black/50 space-y-1 mb-5">
                <p className="flex items-center gap-2"><Users size={14} className="text-[#E63946]" /> {m.leader}</p>
                <p className="pl-6">{m.meeting}</p>
              </div>
              <Link to={`/contact?subject=Ministry%20Information`} data-testid={`ministry-contact-${i}`}
                className="inline-flex items-center gap-1.5 text-sm font-medium text-[#E63946] hover:gap-2.5 transition-all">
                Contact this ministry <ArrowUpRight size={15} />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#E63946] text-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 text-center">
          <Eyebrow dark>Belong Here</Eyebrow>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-6xl leading-[0.95] mb-8 mx-auto max-w-3xl">There's a Place for You at One Love.</h2>
          <Btn to="/plan-your-visit" variant="dark" testid="ministries-cta">Plan Your Visit</Btn>
        </div>
      </section>
    </div>
  );
}
